<mat-toolbar class="toolbar mat-elevation-z3">
  <button mat-icon-button (click)="menuToggle.emit()">
    <mat-icon>menu</mat-icon>
    <!-- <mat-icon mat-list-icon class="chevron-button">chevron_right</mat-icon> -->
  </button>
  <a [routerLink]="['/']">
    <img class="toolbar__image" src="assets/images/svg/logoMenu.svg">
    <!-- <img src="assets/images/Logo-MiEsSalud-ColorHorizontal-white.png" class="toolbar__image" alt="Logotipo"/> -->
  </a>

  <!-- Escarapela -->
  <!-- <img
    class="toolbar__escarapela"
    src="assets/images/escarapela.png"
    alt="Escarapela"> -->

  <span class="toolbar__spacer"></span>
  <p class="fecha" *ngIf="!hideDate">{{ fechaActual }}</p>
  <button mat-button [matMenuTriggerFor]="menu">
    <app-user-avatar [username]="user.nombres"></app-user-avatar>
  </button>

  <mat-menu #menu="matMenu">
    <div style="padding: 0 3% 0 3%; display: flex;">
      <app-user-avatar [username]="user.nombres"></app-user-avatar>
      <div style="display: block; padding-left:3%;">
        <span class="info" style="font-size: 14px;">{{nombre}}</span><br>
        <span class="info" style="font-size: 12px;">{{correo}}</span>
      </div>
    </div>
    <div *ngIf="activaReporte">
      <button mat-menu-item (click)="exportExcel()" *ngIf="activaReporte">
        <mat-icon>cloud_download</mat-icon>
        <span>Reporte panel inf.</span>
      </button>
    </div>
    <button mat-menu-item (click)="logout()">
      <mat-icon>reply</mat-icon>
      <span>Cerrar Sesión</span>
    </button>
  </mat-menu>
</mat-toolbar>